var _g, _ellipse, _g2, _ellipse2, _rect, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 430,
    viewBox: "0 0 518 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.979 160.87V192.492",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61 176.681H420.348",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.18,
    filter: "url(#filter0_f_748_53100)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.084,
    cy: 150.373,
    rx: 97.3586,
    ry: 98.3728,
    fill: "#49E0B3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    filter: "url(#filter1_f_748_53100)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.896,
    cy: 205.15,
    rx: 92.143,
    ry: 94.7956,
    fill: "#190DA0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.43,
    filter: "url(#filter2_f_748_53100)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.51,
    cy: 230.135,
    rx: 114.744,
    ry: 117.153,
    fill: "#5B4B9B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 143.029,
    y: 102.788,
    width: 226.75,
    height: 233.306,
    rx: 113.375,
    fill: "url(#paint0_linear_748_53100)",
    stroke: "url(#paint1_linear_748_53100)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_748_53100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.808,
    y: 228.634,
    width: 229.467,
    height: 129.117,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.538,
    y: 263.499,
    width: 2.42148,
    height: 18.1687,
    rx: 1.21074,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.495 254.002C315.495 256.171 313.786 257.87 311.749 257.87C309.712 257.87 308.002 256.171 308.002 254.002C308.002 251.833 309.712 250.134 311.749 250.134C313.786 250.134 315.495 251.833 315.495 254.002Z",
    stroke: "#3E6496",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.537,
    y: 299.011,
    width: 2.42148,
    height: 26.4273,
    rx: 1.21074,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.495 289.513C315.495 291.682 313.785 293.381 311.748 293.381C309.712 293.381 308.002 291.682 308.002 289.513C308.002 287.344 309.712 285.645 311.748 285.645C313.785 285.645 315.495 287.344 315.495 289.513Z",
    stroke: "#A793F6",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.495 331.632C315.495 333.801 313.785 335.5 311.748 335.5C309.712 335.5 308.002 333.801 308.002 331.632C308.002 329.463 309.712 327.764 311.748 327.764C313.785 327.764 315.495 329.463 315.495 331.632Z",
    stroke: "#F19E5B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.808,
    y: 251.112,
    width: 49.2368,
    height: 5.78096,
    rx: 2.89048,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 248.634,
    width: 115.424,
    height: 5.78096,
    rx: 2.89048,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 284.145,
    width: 42.7795,
    height: 5.78096,
    rx: 2.89048,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 326.264,
    width: 115.424,
    height: 5.78096,
    rx: 2.89048,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 256.892,
    width: 107.352,
    height: 2.47755,
    rx: 1.23878,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.84,
    y: 256.892,
    width: 10.4931,
    height: 2.47755,
    rx: 1.23878,
    fill: "#3E6496"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 292.404,
    width: 107.352,
    height: 2.47755,
    rx: 1.23878,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 297.359,
    width: 90.4019,
    height: 2.47755,
    rx: 1.23878,
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 302.314,
    width: 98.4735,
    height: 2.47755,
    rx: 1.23878,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.066,
    y: 334.522,
    width: 22.6005,
    height: 2.47755,
    rx: 1.23878,
    fill: "#F19E5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.088,
    y: 334.522,
    width: 30.6721,
    height: 2.47755,
    rx: 1.23878,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.108,
    y: 286.623,
    width: 37.9365,
    height: 5.78096,
    rx: 2.89048,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.229,
    y: 327.09,
    width: 46.8153,
    height: 5.78096,
    rx: 2.89048,
    fill: "#F2F2F7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_748_53100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1011 162.77C87.1011 156.142 92.4737 150.77 99.1011 150.77H306.947C313.575 150.77 318.947 156.142 318.947 162.77V229.447C318.947 236.074 313.575 241.447 306.947 241.447H99.1011C92.4737 241.447 87.1011 236.075 87.1011 229.447V162.77Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.954 220.469C295.954 220.469 272.362 183.295 248.77 183.295C225.179 183.295 225.179 197.596 201.587 197.596C177.995 197.596 179.148 229.705 143.798 207.314C122.896 194.075 107.22 220.749 107.22 220.749",
    fill: "#F2F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.22 221.128V170.861",
    stroke: "#D0D2DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.045 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.87 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.738 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.563 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.388 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M267.213 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.038 221.128V170.861",
    stroke: "#D0D2DB",
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.22 221.128L300.744 221.128",
    stroke: "#D0D2DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M293.126 196.255C293.126 196.255 269.889 216.298 246.652 216.298C223.414 216.298 223.414 204.606 200.177 204.606C176.94 204.606 178.075 178.355 143.258 196.661C122.67 207.485 107.229 185.677 107.229 185.677",
    stroke: "#A793F6",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.154 195.329C296.154 194.711 295.93 194.119 295.533 193.682C295.136 193.245 294.597 193 294.034 193C293.472 193 292.933 193.245 292.536 193.682C292.138 194.119 291.915 194.711 291.915 195.329C291.915 195.947 292.138 196.54 292.536 196.977C292.933 197.414 293.472 197.659 294.034 197.659C294.597 197.659 295.136 197.414 295.533 196.977C295.93 196.54 296.154 195.947 296.154 195.329Z",
    fill: "#A793F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.224 206.646C216.224 206.028 216.001 205.435 215.603 204.998C215.206 204.561 214.667 204.316 214.105 204.316C213.542 204.316 213.003 204.561 212.606 204.998C212.208 205.435 211.985 206.028 211.985 206.646C211.985 207.263 212.208 207.856 212.606 208.293C213.003 208.73 213.542 208.975 214.105 208.975C214.667 208.975 215.206 208.73 215.603 208.293C216.001 207.856 216.224 207.263 216.224 206.646Z",
    fill: "#A793F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242.868 215.965C242.868 215.347 242.644 214.754 242.247 214.317C241.849 213.881 241.31 213.635 240.748 213.635C240.186 213.635 239.647 213.881 239.25 214.317C238.852 214.754 238.629 215.347 238.629 215.965C238.629 216.583 238.852 217.175 239.25 217.612C239.647 218.049 240.186 218.295 240.748 218.295C241.31 218.295 241.849 218.049 242.247 217.612C242.644 217.175 242.868 216.583 242.868 215.965Z",
    fill: "#A793F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.511 211.305C269.511 210.687 269.287 210.095 268.89 209.658C268.493 209.221 267.953 208.975 267.391 208.975C266.829 208.975 266.29 209.221 265.893 209.658C265.495 210.095 265.272 210.687 265.272 211.305C265.272 211.923 265.495 212.516 265.893 212.953C266.29 213.39 266.829 213.635 267.391 213.635C267.953 213.635 268.493 213.39 268.89 212.953C269.287 212.516 269.511 211.923 269.511 211.305Z",
    fill: "#A793F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.937 190.004C162.937 189.386 162.714 188.793 162.316 188.357C161.919 187.92 161.38 187.674 160.818 187.674C160.256 187.674 159.717 187.92 159.319 188.357C158.922 188.793 158.698 189.386 158.698 190.004C158.698 190.622 158.922 191.214 159.319 191.651C159.717 192.088 160.256 192.334 160.818 192.334C161.38 192.334 161.919 192.088 162.316 191.651C162.714 191.214 162.937 190.622 162.937 190.004Z",
    fill: "#A793F6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.58 201.32C189.58 200.702 189.357 200.11 188.96 199.673C188.562 199.236 188.023 198.99 187.461 198.99C186.899 198.99 186.36 199.236 185.962 199.673C185.565 200.11 185.342 200.702 185.342 201.32C185.342 201.938 185.565 202.531 185.962 202.967C186.36 203.404 186.899 203.65 187.461 203.65C188.023 203.65 188.562 203.404 188.96 202.967C189.357 202.531 189.58 201.938 189.58 201.32Z",
    fill: "#A793F6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.294 199.323C136.294 198.705 136.071 198.113 135.673 197.676C135.276 197.239 134.737 196.993 134.175 196.993C133.613 196.993 133.074 197.239 132.676 197.676C132.279 198.113 132.055 198.705 132.055 199.323C132.055 199.941 132.279 200.534 132.676 200.971C133.074 201.408 133.613 201.653 134.175 201.653C134.737 201.653 135.276 201.408 135.673 200.971C136.071 200.534 136.294 199.941 136.294 199.323Z",
    fill: "#A793F6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.501 186.01C110.501 185.392 110.278 184.8 109.88 184.363C109.483 183.926 108.944 183.68 108.382 183.68C107.82 183.68 107.281 183.926 106.883 184.363C106.486 184.8 106.262 185.392 106.262 186.01C106.262 186.628 106.486 187.22 106.883 187.657C107.281 188.094 107.82 188.34 108.382 188.34C108.944 188.34 109.483 188.094 109.88 187.657C110.278 187.22 110.501 186.628 110.501 186.01Z",
    fill: "#A793F6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_748_53100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.856,
    y: 75.8623,
    width: 237.595,
    height: 86.7348,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.856,
    y: 90.2297,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.856,
    y: 106.23,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.856,
    y: 122.23,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.856,
    y: 138.23,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 92.2278H388.818C390.475 92.2278 391.818 93.5709 391.818 95.2278C391.818 96.8846 390.475 98.2278 388.818 98.2278H237.856V92.2278Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 92.2297H354.489C356.146 92.2297 357.489 93.5729 357.489 95.2297C357.489 96.8866 356.146 98.2297 354.489 98.2297H237.856V92.2297Z",
    fill: "#3E6496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 92.2297H275.427C277.084 92.2297 278.427 93.5729 278.427 95.2297C278.427 96.8866 277.084 98.2297 275.427 98.2297H237.856V92.2297Z",
    fill: "#65AAA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 108.23H365.255C366.912 108.23 368.255 109.573 368.255 111.23C368.255 112.887 366.912 114.23 365.255 114.23H237.856V108.23Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 108.23H351.4C353.057 108.23 354.4 109.573 354.4 111.23C354.4 112.887 353.057 114.23 351.4 114.23H237.856V108.23Z",
    fill: "#65AAA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 108.23H278.051C279.708 108.23 281.051 109.573 281.051 111.23C281.051 112.887 279.708 114.23 278.051 114.23H237.856V108.23Z",
    fill: "#FD8897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 124.23H311.856C313.513 124.23 314.856 125.573 314.856 127.23C314.856 128.887 313.513 130.23 311.856 130.23H237.856V124.23Z",
    fill: "#9F6490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 124.23H276.856C278.513 124.23 279.856 125.573 279.856 127.23C279.856 128.887 278.513 130.23 276.856 130.23H237.856V124.23Z",
    fill: "#D73F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 124.23H242.856C244.513 124.23 245.856 125.573 245.856 127.23C245.856 128.887 244.513 130.23 242.856 130.23H237.856V124.23Z",
    fill: "#3E6496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 140.231H382.535C384.192 140.231 385.535 141.575 385.535 143.231C385.535 144.888 384.192 146.231 382.535 146.231H237.856V140.231Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.856 140.23H308.696C310.353 140.23 311.696 141.573 311.696 143.23C311.696 144.887 310.353 146.23 308.696 146.23H237.856V140.23Z",
    fill: "#E8BF39"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.853 265.05V290.09",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.683 277.57H131.023",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.892 305.126V319.733",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.793 312.429H152.991",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_748_53100",
    x: 22.7251,
    y: 0,
    width: 298.717,
    height: 300.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_748_53100"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_748_53100",
    x: 168.753,
    y: 28.3547,
    width: 348.286,
    height: 353.591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_748_53100"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_748_53100",
    x: 0.766113,
    y: 30.9817,
    width: 393.488,
    height: 398.306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_748_53100"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_748_53100",
    x: 210.808,
    y: 213.634,
    width: 269.467,
    height: 169.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_748_53100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_748_53100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_748_53100",
    x: 41.4775,
    y: 138.77,
    width: 323.094,
    height: 114.677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_748_53100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_748_53100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_748_53100",
    x: 186.856,
    y: 60.8623,
    width: 277.595,
    height: 126.735,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_748_53100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_748_53100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_748_53100",
    x1: 51.429,
    y1: -43.1224,
    x2: 491.381,
    y2: 131.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_748_53100",
    x1: 169.042,
    y1: 130.067,
    x2: 332.309,
    y2: 309.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFE2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5BFF",
    stopOpacity: 0.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessContent);
export default __webpack_public_path__ + "static/media/business-content.c8ef70a91e4105b901cf145dcba0f19b.svg";
export { ForwardRef as ReactComponent };